export default function isBladeNew(releaseDate) {
  if (!releaseDate) return false;

  const releaseDateObj = new Date(releaseDate); // Assuming releaseDate is a valid date string
  const currentDate = new Date();
  const fourMonthsAgo = new Date();
  fourMonthsAgo.setMonth(currentDate.getMonth() - 4);

  return releaseDateObj >= fourMonthsAgo;
}
